import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';

const fetchBarrelBalance = async () => {
  const endPoint = `${apiConfig(
    'loyaltyWallet',
    'v1'
  )}/lws/amount?wallet_type=FW`;

  const { response, error }: any = await getMethod({
    endPoint,
  });
  if (response) {
    return { response: { fuelBalance: response?.data?.amount } };
  } else if (error) {
    return { error: error };
  }
};

export default fetchBarrelBalance;
